import * as Yup from "yup";

const loginschema = Yup.object({
  email: Yup.string()
    .email("Invalid email address")
    .matches(
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
      "Invalid email address",
    )
    .required("Email is Required"),
  role: Yup.string().required("Profile is Required"),

  password: Yup.string()
    .min(8, "Password must be at least 8 characters")
    .max(20, "Password cannot be more than 20 characters")
    .matches(/[a-z]/, "Password must contain at least one lowercase letter")
    .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
    .matches(/[0-9]/, "Password must contain at least one number")
    .matches(
      /[!@#$%^&*(),.?":{}|<>]/,
      "Password must contain at least one special character",
    )
    .required("Password is required"),
});

const signUpschema = Yup.object({
  name: Yup.string().required(" Name is Required"),
  role: Yup.string().required(" Role is Required"),

  email: Yup.string()
    .email("Invalid email address")
    .matches(
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
      "Invalid email address",
    )
    .required("Email is Required"),

  password: Yup.string()
    .min(8, "Password must be at least 8 characters")
    .max(20, "Password cannot be more than 20 characters")
    .matches(/[a-z]/, "Password must contain at least one lowercase letter")
    .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
    .matches(/[0-9]/, "Password must contain at least one number")
    .matches(
      /[!@#$%^&*(),.?":{}|<>]/,
      "Password must contain at least one special character",
    )
    .required("Password is required"),

  confirmPassword: Yup.string()
    .oneOf([Yup.ref("password"), undefined], "Passwords must match")
    .required("Confirm Password is Required"),
});

const resetpassword = Yup.object({
  password: Yup.string()
    .min(8, "Password must be at least 8 characters")
    .max(20, "Password cannot be more than 20 characters")
    .matches(/[a-z]/, "Password must contain at least one lowercase letter")
    .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
    .matches(/[0-9]/, "Password must contain at least one number")
    .matches(
      /[!@#$%^&*(),.?":{}|<>]/,
      "Password must contain at least one special character",
    )
    .required("Password is required"),

  confirmPassword: Yup.string()
    .oneOf([Yup.ref("password"), undefined], "Passwords must match")
    .required("Confirm Password is Required"),
});

const ForgetPasswordScheema = Yup.object({
  email: Yup.string()
    .email("Invalid email address")
    .matches(
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
      "Invalid email address",
    )
    .required("Email is Required"),
});

const userValidationSchema = Yup.object({
  fullName: Yup.string()
    .required("Name is required")
    .matches(/^[a-zA-Z\s]+$/, "Name must only contain letters"),

  email: Yup.string()
    .email("Invalid email address")
    .matches(
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
      "Invalid email address",
    )
    .required("Email is Required"),

  phoneNumber: Yup.string()
    .required("Phone number is required")
    .matches(
      /^(\+\d{1,2}\s?)?1?\-?\.?\s?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/,
      "Invalid phone number format",
    ),

  address: Yup.string().required("Address is required"),
  addressType: Yup.string().required("Address type is required"),

  city: Yup.string()
    .required("City is required")
    .matches(/^[a-zA-Z\s]+$/, "City must only contain letters"),

  country: Yup.string()
    .required("Country is required")
    .matches(/^[a-zA-Z\s]+$/, "Country must only contain letters"),

  postalCode: Yup.string().required("Postal code is required"),
  // .matches(/^\d{5}(-\d{4})?$/, "Postal code is not valid"),
  accountHolderName: Yup.string()
    .required("Account Holder Name is required")
    .matches(/^[a-zA-Z\s]+$/, "Account Holder Name must only contain letters"),
  bankName: Yup.string().required("Bank name is required"),

  accountNumber: Yup.string()
    .required("Account number is required")
    .matches(/^\d+$/, "Account number must contain only numbers"),

  IFSC: Yup.string()
    .required("IFSC code is required")
    .matches(/^[A-Z]{4}0[A-Z0-9]{6}$/, "Invalid IFSC code"),
});

const courseContentvalidation = Yup.object({
  sections: Yup.array().of(
    Yup.object({
      title: Yup.string().required("Section title is required"),
      //   description: Yup.string(),
      lectures: Yup.array().of(
        Yup.object({
          title: Yup.string().required("Lecture title is required"),
          description: Yup.string(),
        }),
      ),
    }),
  ),
});

const courseDescriptionValidation = Yup.object({
  learningObjectives: Yup.array()
    .of(Yup.string().required("This field is required"))
    .min(3, "At least 3 learning objectives required"),
  whoCanJoin: Yup.string().required("This field is required"),
  requiredSkills: Yup.string().required("This field is required"),
});

const createCourseValidations = Yup.object({
  title: Yup.string().required("Course title is required"),
  subtitle: Yup.string(),
  description: Yup.string().required("Course description is required"),
  category: Yup.string().required("Category is required"),
  level: Yup.string().required("Level is required"),
  language: Yup.string().required("Language is required"),
  coverImage: Yup.mixed().required("Course cover image is required"),
  shortVideo: Yup.mixed().required("Course short video is required"),
});

const questionCourseInfoScheema = Yup.object({
  courseName: Yup.string().required("Course name is required"),
  section: Yup.string().required("Section no/name is required"),
});

const questionScheema = Yup.object().shape({
  questions: Yup.array().of(
    Yup.object().shape({
      question: Yup.string().required("Question is required"),
    }),
  ),
});

const coursePriceValidation = Yup.object().shape({
  currency: Yup.string().required("Currency is required"),
  amount: Yup.string().required("Amount is required"),
});

export {
  loginschema,
  signUpschema,
  resetpassword,
  ForgetPasswordScheema,
  userValidationSchema,
  courseContentvalidation,
  courseDescriptionValidation,
  createCourseValidations,
  questionCourseInfoScheema,
  questionScheema,
  coursePriceValidation,
};
